(function () {
  'use strict';

  /* Minimaler Ripple auf jeden Click — kein Spam */
  document.addEventListener('click', function (e) {
    var el = document.createElement('div');
    el.className = 'clk-ripple';
    el.style.left = e.clientX + 'px';
    el.style.top  = e.clientY + 'px';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 650);
  }, true);
})();
